import _ from 'underscore';
import requiredness from 'gw-portals-questionsets-js/aspects/Requiredness';
import validity from 'gw-portals-questionsets-js/aspects/Validity';
import availableValues from 'gw-portals-questionsets-js/aspects/AvailableValues';

var INPUT_CTRL_TYPES = {
    'Choice': 'SELECT',
    'String': 'TEXT',
    'Boolean': 'RADIO'
};

function createQuestionSetViewModel(questionSets, modelValue, translator) {
    function createQuestionViewModel(question) {
        var questionVmNode = {
            get code() {
                return question.code;
            },
            get label() {
                return question.displayKey;
            },
            get answer() {
                var answer = modelValue.answers[question.code];

                switch (answer) {
                    // See history. Previous implementation worked by coincidence
                    // because of implicit string to boolean conversion by angular.
                    // This emulates previous behaviour
                    case 'false':
                        return false;
                    case 'true':
                        return true;
                    default:
                        return answer;
                }
            },
            get value() {
                return this.answer;
            },

            set answer(answerValue) {
                if (typeof answerValue === 'boolean') {
                    // See history. Previous implementation worked by coincidence
                    // because of implicit string to boolean conversion by angular.
                    // This emulates previous behaviour
                    answerValue = answerValue ? 'true' : 'false';
                }

                modelValue.answers[question.code] = answerValue;
            },
            set value(val) {
                this.answer = val;
            },

            get type() {
                return INPUT_CTRL_TYPES[question.questionType];
            },
            aspects: {}
        };

        var aspectProperties = requiredness(questionVmNode, question, modelValue.answers);
        _.extendOwn(aspectProperties, validity(questionVmNode, translator));
        _.extendOwn(aspectProperties, availableValues(question));

        Object.getOwnPropertyNames(aspectProperties).forEach(function (propName) {
            Object.defineProperty(questionVmNode.aspects, propName, aspectProperties[propName]);
        });

        return questionVmNode;
    }

    function getQuestionSet(qsName) {
        var questionSet = questionSets[qsName];
        if (!questionSet || !questionSet.orderedQuestions) {
            throw new Error('There is no question set loaded with the name ' + qsName);
        }
        return questionSet;
    }

    // note: uses ducktyping, checking if answers is a view model object by looking at aspects property
    // if view model already created then just return that object
    if (modelValue.aspects && modelValue.questions && _.isArray(modelValue.questions)) {
        return modelValue;
    }

    var qsViewModel = {
        value: modelValue
    };
    var questionSet = getQuestionSet(modelValue.code);

    var allQuestions = questionSet.orderedQuestions.sort(function (a, b) {
        return a.order - b.order;
    });

    var availableQuestions = _.filter(allQuestions, function (question) {
        return modelValue.answers[question.code] !== undefined;
    });
    qsViewModel.questions = availableQuestions.map(createQuestionViewModel);

    return qsViewModel;
}

export default {
    create: function create(questionSets, translator) {
        return {
            /**
             * Creates a new question set view model object with aspects expected by form input controls.
             *
             * @param {Object | Array} qsModelArrayOrObject : QuestionSetAnswersDTO model object or array that is used to create the view model. If the object
             * passed in is a view model object then it will just be returned as is
             *
             * @returns {Array}: A new view model object or array of view model objects with a top level serializedForm aspect
             */
            getQuestionSetViewModel: function getQuestionSetViewModel(qsModelArrayOrObject) {
                if (!qsModelArrayOrObject && !(_.isObject(qsModelArrayOrObject) || _.isArray(qsModelArrayOrObject))) {
                    throw new Error('An model object is required for storing answers');
                }

                if (_.isArray(qsModelArrayOrObject)) {
                    return qsModelArrayOrObject.map(function (qsModel) {
                        return createQuestionSetViewModel(questionSets, qsModel, translator);
                    });
                }

                return [createQuestionSetViewModel(questionSets, qsModelArrayOrObject, translator)];
            }
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-questionsets-angular/QuestionSetFactory.js
// module id = 899
// module chunks = 0